<!--
  This work has been created or enhanced by
    Markus Luckey, 2025, KERNBLICK GmbH

  This file is covered by the EU PL 1.2 license.
  You may obtain a copy of the licence at
  https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
-->

<template>
  <div class="welcome container mb-5">
    <img
      src="/img/civitascore.png"
      alt="CIVITAS/CORE Logo"
      class="img-fluid mx-auto d-block mb-5 mt-3"
      style="max-width: 300px;"
    >
    <h1 class="mb-5 text-center">
      {{ $t('welcome') }}
    </h1>
    <h2 class="mt-5">
      {{ $t('services') }}
    </h2>
    <div
      v-if="apps.length"
      class="row row-cols-1 row-cols-md-4 g-4"
    >
      <div
        v-for="(app, index) in filteredApps"
        :key="index"
        class="col"
      >
        <div class="card h-100">
          <img
            :src="app.icon"
            :alt="app.name"
            class="card-img-top align-self-center p-2"
            style="max-width: 150px; max-height: 150px"
          >
          <div class="card-body">
            <h5 class="card-title">
              {{ app.name }}
            </h5>
            <p class="card-text">
              {{ app.description[$i18n.locale] || Object.values(app.description)[0] || 'no description' }}
            </p>
          </div>
          <div class="card-footer">
            <BButton
              class=""
              :to="app.iframe ? app.path : false"
              :href="!app.iframe ? app.url : false"
              :target="!app.iframe ? '_blank' : false"
              :variant="urlStatuses[app.id] == 'fa-times-circle' ? 'danger' : (urlStatuses[app.id] == 'fa-check-circle' ? 'success' : 'primary')"
            >
              <font-awesome-icon
                :v-if="urlStatuses[app.id]"
                :icon="['fas', ...(urlStatuses[app.id] ?? ['question-circle']) ]"
              />
              {{ urlStatuses[app.id] == 'fa-check-circle'
                ? $t('navigate')
                : (urlStatuses[app.id] == 'fa-times-circle' ? $t('offline') : $t('unknown')) }}
            </BButton>
          </div>
        </div>
      </div>
    </div>

    <div v-if="CERT_CIVITAS_CRT || CERT_CIVITAS_CRL || CERT_CIVITAS_CRL_PEM">
      <h2 class="mt-5">
        {{ $t('localCA') }}
      </h2>
      <ul>
        <li v-if="CERT_CIVITAS_CRT">
          <a :href="CERT_CIVITAS_CRT">{{ $t('downloadCACert') }}</a>
        </li>
        <li v-if="CERT_CIVITAS_CRL">
          <a :href="CERT_CIVITAS_CRL">{{ $t('downloadCRL') }}</a>
        </li>
        <li v-if="CERT_CIVITAS_CRL_PEM">
          <a :href="CERT_CIVITAS_CRL_PEM">{{ $t('downloadCRLPem') }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue';
import { PROXY_URL, CERT_CIVITAS_CRT, CERT_CIVITAS_CRL, CERT_CIVITAS_CRL_PEM } from '@/EnvProvider';
import Mgr from '@/services/SecurityService';
import { BButton } from 'bootstrap-vue-next';
export default {
  name: 'Home',
  components: {
    BButton
  },
  props: {
    apps: { type: Array, default: () => [] }
  },
  data() {
    return {
      mgr: new Mgr(),
      urlStatuses: reactive({}),
      roles: reactive([]),
      CERT_CIVITAS_CRT,
      CERT_CIVITAS_CRL,
      CERT_CIVITAS_CRL_PEM
    };
  },
  computed: {
    filteredApps() {
      return this.apps.filter((app) => {
        return (!app.role || this.roles.includes(app.role)) && !app.hide;
      });
    }
  },
  async mounted() {
    this.urlStatuses = {};
    setTimeout(this.checkAllUrls, 1000);
    setInterval(this.checkAllUrls, 20000);

    if (this.mgr.isAuthorizationEnabled()) {
      this.roles = (await this.mgr.getRoles()) || [];
    } else {
      this.roles = [];
    }
  },
  methods: {
    checkUrlAvailability(app) {
      const appId = app.id;
      try {
        fetch(PROXY_URL + encodeURIComponent(appId), { method: 'GET' })
          .then(async response => {
            let body = JSON.parse(await response.text() || '{ status: 500 }');
            let goodStatuses = [200, 201, 202, 203, 204, 205, 206, 207, 208, 226, ...(app.goodStatuses || [])];
            this.urlStatuses[appId] = (response.ok && goodStatuses.includes(body.status)) ? ['fa-check-circle'] : ['fa-times-circle'];
          })
          .catch(() => {
            this.urlStatuses[appId] = ['fa-question-circle'];
          });
      } catch (error) {
        console.debug("Connection error", error);
        this.urlStatuses[appId] = ['fa-question-circle'];
      }
    },
    checkAllUrls() {
      if (!this.apps) return;
      this.apps.forEach(app => {
        this.urlStatuses[app.id] = this.urlStatuses[app.id] ?? ['fa-question-circle'];
        this.checkUrlAvailability(app);
      });
    }
  }
};

</script>
